import * as t from 'io-ts';
export function createCodec(typeName, isTypeFunc) {
    return new t.Type(typeName, isTypeFunc, function (value, context) { return (isTypeFunc(value) ? t.success(value) : t.failure(value, context)); }, t.identity);
}
export function isPresent(variable) {
    return variable !== undefined && variable !== null && variable !== '';
}
export function isSerializable(variable) {
    try {
        JSON.stringify(variable);
    }
    catch (e) {
        return false;
    }
    return true;
}
export function OptionalArg(codec) {
    return t.union([codec, t.undefined]);
}
export var NonEmptyString = createCodec('NonEmptyString', function (s) { return t.string.is(s) && isPresent(s); });
//# sourceMappingURL=modelUtils.js.map